import React from 'react'
import { FieldArray } from 'formik';
import {
    Box,
    TextField,
    Typography,
} from '@mui/material';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ProductForm from './ProductForm';
import ProjectForm from './ProjectForm';

const ExportForm = ({ formik, totalPrice }) => {
    return (
        <FieldArray
            name="prdtList"
            render={arrayHelpers => (
                <Box>
                    {formik.values?.prdtList.length === 0 ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Typography variant="subtitle2" component="div">선택된 출고제품이 없습니다.</Typography>
                        </Box>

                    ) : (
                        <Box>
                            <Box sx={{ my: 2 }}>
                                <Box >
                                    <ProjectForm formik={formik} />
                                </Box>
                                <Box>
                                    <TextField
                                        margin="normal"
                                        required={true}
                                        variant="outlined"
                                        fullWidth
                                        id="outDesc"
                                        name="outDesc"
                                        label="출고사유"
                                        value={formik.values.outDesc}
                                        onChange={formik.handleChange}
                                        error={formik.touched.outDesc && Boolean(formik.errors.outDesc)}
                                        helperText={formik.touched.outDesc && formik.errors.outDesc}
                                        multiline
                                        rows={4}
                                    />
                                </Box>
                            </Box>


                            <Box sx={{
                                display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 2,
                                borderBottom: (theme) => `1px solid ${theme.palette.divider}`,

                            }}>
                                <Box><Typography variant="subtitle2" component="div">총 {formik.values?.prdtList.length}건</Typography></Box>
                                <Box><Typography variant="subtitle2" component="div">총합 : ₩ {totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Typography></Box>
                            </Box>
                            <TableContainer component={Box}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>No</TableCell>
                                            <TableCell>제조사</TableCell>
                                            <TableCell>매입처</TableCell>
                                            <TableCell>제품명</TableCell>
                                            <TableCell>모델명</TableCell>
                                            <TableCell>수량</TableCell>
                                            <TableCell>단가</TableCell>
                                            <TableCell>삭제</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {formik.values?.prdtList.map((p, index) => {
                                            return (
                                                <ProductForm
                                                    key={index}
                                                    product={p}
                                                    index={index}
                                                    formik={formik}
                                                    handleRemove={() => arrayHelpers.remove(index)}
                                                />
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                        </Box>

                    )}

                </Box>

            )}

        >

        </FieldArray>
    )
}

export default ExportForm